const actionTypes = {
    FETCH_EMPLOYEES: 'FETCH_EMPLOYEES',
    CREATE_EMPLOYEE: 'CREATE_EMPLOYEE',
    UPDATE_EMPLOYEE: 'UPDATE_EMPLOYEE',
    DELETE_EMPLOYEE: 'DELETE_EMPLOYEE'
};

export { actionTypes };
